import { apiClient } from "../client";
const ENDPOINTS = {
    LIST: "/shopping-centres",
};
export const shoppingCentresService = {
    getShoppingCentres: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.search)
            params.append("search", filters.search);
        if (filters.state)
            params.append("state", filters.state);
        if (filters.page)
            params.append("page", filters.page.toString());
        if (filters.pageSize)
            params.append("pageSize", filters.pageSize.toString());
        const queryString = params.toString();
        const response = await apiClient.get(`${ENDPOINTS.LIST}${queryString ? `?${queryString}` : ""}`);
        return { data: response.data };
    },
    getShoppingCentre: async (id) => {
        const response = await apiClient.get(`${ENDPOINTS.LIST}/${id}`);
        return { data: response.data.shoppingCentre };
    },
    createShoppingCentre: async (dto) => {
        const response = await apiClient.post(ENDPOINTS.LIST, dto);
        return { data: response.data.shoppingCentre };
    },
    updateShoppingCentre: async (id, dto) => {
        const response = await apiClient.put(`${ENDPOINTS.LIST}/${id}`, dto);
        return { data: response.data.shoppingCentre };
    },
    deleteShoppingCentre: async (id) => {
        await apiClient.delete(`${ENDPOINTS.LIST}/${id}`);
    },
};
